<template>
  <div>
    <!-- {{ chartData }} -->
    <Line
      id="my-chart-id"
      :options="chartOptions"
      :data="chartData"
      :height="height"
    />
  </div>
  <!-- :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height" -->
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default {
  name: "LineChart",
  components: { Line },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Object,
      default: () => {},
    },
    chartOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      //   chartData: {
      //     labels: ["January", "February", "March"],
      //     datasets: [
      //       {
      //         label: "Data",
      //         fill: true,
      //         //   borderColor: config.colors.primary,
      //         borderWidth: 2,
      //         borderDash: [],
      //         borderDashOffset: 0.0,
      //         //   pointBackgroundColor: config.colors.primary,
      //         pointBorderColor: "rgba(255,255,255,0)",
      //         pointHoverBackgroundColor: "#be55ed",
      //         pointBorderWidth: 20,
      //         pointHoverRadius: 4,
      //         pointHoverBorderWidth: 15,
      //         pointRadius: 4,
      //         data: [40, 20, 12],
      //       },
      //     ],
      //   },
      //   chartOptions: {
      //     responsive: true,
      //   },
    };
  },
  watch: {
    chartData: {
      handler(val, oldVal) {
        console.log("book list changed");
        console.log(val);
      },
      deep: true,
    },
  },
};
</script>
